import React from "react"
import cx from "classnames"
// import { Emoji } from "emoji-mart"
import { isAldeia } from "hooks/useAldeia"

function ColorEmojiIcon(props) {
  const { icon, iconStyle, size = 8, iconName = "fas fa-circle" } = props
  if (!icon) return null
  if (typeof icon == "function") return <i>{icon()}</i>
  if (icon.indexOf("fa-") > -1 || icon.indexOf("css-") > -1) return <i className={icon} style={iconStyle} />
  if (icon.indexOf("#") > -1)
    // return <IconMaterialSymbolsLightFilterTiltShift style={{ fontSize: 9, ...iconStyle, color: icon === "#78909c" ? undefined : icon }} />
    return <i className={cx(iconName, { roundeable: props.roundeable })} style={{ color: icon, fontSize: 9, ...iconStyle }} />

  return (
    <i style={iconStyle} className={cx("icon", props.className, { roundeable: props.roundeable })}>
      {/* <em-emoji shortcodes={icon} size={size} native></em-emoji> */}
      {/* @ts-ignore */}
      <em-emoji shortcodes={icon} size={size} set={isAldeia ? "twitter" : "native"}></em-emoji>
    </i>
  )
}

export default ColorEmojiIcon
